import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { AdminData, AdminRightData } from '../../_models/admin';
import { CountryData } from '../../_models/country';
import { Counts } from '../../_models/data';
import { HrStaffData } from '../../_models/hr';
import { UserData } from '../../_models/users';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';

@Component({
  selector: 'app-administrator',
  templateUrl: './administrator.component.html',
  styleUrl: './administrator.component.css'
})
export class AdministratorComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  
  userData: AdminData;
  page: number = 1;
  count: Counts;

  url = this.router.url.slice(1);

  mainHeader: string = "List All Administrators";
  formHeader: string = "Add New Administrator";
  view: string = "";

  processing: boolean = false;
  loading: boolean = true;
  buttonText: string = "Add New Administrator";

  countryList: CountryData[] = [];
  adminList: AdminData[] = [];
  staffList: HrStaffData[] = [];
  staffAdminRefs: number[] = [];
  oneAdmin: AdminData;
  adminRightList: AdminRightData[] = [];

  edit: boolean = false;
  viewOne: boolean = false;

  adminName: string = "";
  adminRef: number = 0;

  dataForm = this.fb.group({
    ref: [0],
    lname: ["", Validators.required],
    fname: ["", Validators.required],
    email: [{value: "", disabled: false}, Validators.required],
    adminType: [0, Validators.required],
  }, {});
  
  get ref() { return this.dataForm.get('ref'); }
  get lname() { return this.dataForm.get('lname'); }
  get fname() { return this.dataForm.get('fname'); }
  get email() { return this.dataForm.get('email'); }
  get adminType() { return this.dataForm.get('adminType'); }

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.userData = this.checkService.checkSession();
    this.getRouteParams();
    this.listAdminRight();
    this.oneAdmin = new AdminData();
  }

  ngOnInit(): void {
    if (this.routeParams['view'] !== undefined) {
      let view = '';
      this.view = view = this.routeParams['view'];
      if (this.view == "newPassword") {
        this.view = "CHANGE_PASSWORD";
        view = "Pending Password Change";
      }
      this.mainHeader = "List "+view+" Administrators";
    }

    if (this.queryParams['page'] !== undefined) {
      this.page = this.queryParams['page'];
    } else {
      this.page = 1;
    }
    this.listAdministrator(this.page);
    this.listStaffProfiles();
  }

  listAdminRight() {
    this.loading = true;

    this.apiService.listAdminRight().subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.adminRightList = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );
  }

  listAdministrator(page) {
    this.loading = true;

    this.apiService.listAdministrator(page, this.view).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.count = data.counts;
          this.adminList = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );
  }

  listStaffProfiles(page:number = 1, reset:boolean = true) {
    if (reset) {
      this.staffList = [];
      this.staffAdminRefs = [];
    }

    this.apiService.getHrStaff(page).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.staffList = this.staffList.concat(data.data || []);
          (data.data || []).forEach(staff => {
            const adminRef = Number(staff.admin?.ref || 0);
            if (adminRef > 0 && this.staffAdminRefs.indexOf(adminRef) === -1) {
              this.staffAdminRefs.push(adminRef);
            }
          });

          if (data.counts && page < Number(data.counts.totalPage || 1)) {
            this.listStaffProfiles(page + 1, false);
          }
        }
      }
    );
  }

  getCountries() {
    this.loading = true;

    this.apiService.getCountries(0, "list").subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.countryList = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }

  onCreate() {
    var data: object = {
      lname: this.dataForm.value.lname,
      fname: this.dataForm.value.fname,
      email: this.dataForm.value.email,
      adminType: this.dataForm.value.adminType
    };
    if (this.edit === true) {
      data['ref'] = this.dataForm.value.ref;
      this.editAdnin(data);
    } else {
      data['country'] = this.userData.country.iso;
      
      this.createAdmin(data);
    }
  }

  editAdnin( data ) {
    this.processing = true;

    this.buttonText = "Saving Changes...";
      
    this.apiService.modifyAdmin(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("saved changes made to Administrator", "Administrator Edited");
          this.checkService.closeModal('modal-admin-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Administrator";
        this.edit = false;
      }
    );
  }

  createAdmin( data ) {
    this.processing = true;

    this.buttonText = "Adding New Administrator...";
    this.apiService.createAdmin(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Created "+data.name+" as an Administrator", "Administrator Created");
          this.checkService.closeModal('modal-admin-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Administrator";
        this.edit = false;
      }
    );
  }

  viewAdmin(data:AdminData) {
    this.viewOne = true;
    this.oneAdmin = data;
  }

  closeAdminDrawer() {
    this.viewOne = false;
    this.oneAdmin = null;
  }

  getEdit(data:AdminData) {
    this.dataForm.patchValue({
      ref: data.ref,
      lname: data.lastName,
      fname: data.firstName,
      email: data.email,
      adminType: data.rights.ref
    });
    this.dataForm.controls.email.disable();
    this.edit = true;
    this.formHeader = "Edit "+data.nickName;
    this.buttonText = "Edit Administrator";
  }

  onCancel() {
    this.edit = false;
    this.dataForm.reset();
    this.dataForm.controls.email.enable();
    this.formHeader = this.buttonText = "Add New Administrator";
  }
  
  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }

  changeAdminStatus(action:string, ref:number) {
    let data:Object = {
      ref: ref,
      status: action.toLowerCase()
    }

    this.processing = true;

    this.apiService.changeAdminStatus(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Changes made to Administrator successfully", "Administrator Modified");
          this.ngOnInit();
          if (action == "approve") {
            this.notifyService.showSuccess("Administrator is now active and will now be pushed to the users", "Administrator Activated");
          }
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-delete').click();
        document.getElementById('modal-reset').click();
      }
    );
  }

  deleteAdmin(ref:number) {
    this.processing = true;

    this.apiService.deleteAdmin(ref).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Administrator Removed Successfully", "Administrator Deleted");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-delete').click();
        document.getElementById('modal-reset').click();
      }
    );
  }

  resetAdminPassword(ref:number) {
    this.processing = true;

    this.apiService.resetAdminPassword(ref).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Administrator Password Reset Successfully", "Administrator Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-delete').click();
        document.getElementById('modal-reset').click();
      }
    );
  }

  createStaffFromAdmin(adminRow: AdminData) {
    const country = adminRow.country?.iso || this.userData.country?.iso || '';
    const data = {
      firstName: adminRow.firstName,
      lastName: adminRow.lastName,
      email: '',
      c_email: adminRow.email,
      phone: '',
      jobTitle: '',
      department: '',
      employmentType: 'Full time',
      country: country,
      countries: country !== '' ? [country] : [],
      admin: adminRow.ref,
    };

    this.processing = true;
    this.apiService.createHrStaff(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false;
        if (user.success == true) {
          this.notifyService.showSuccess("Staff profile created and linked to administrator", "Staff Created");
          if (this.staffAdminRefs.indexOf(adminRow.ref) === -1) {
            this.staffAdminRefs.push(adminRow.ref);
          }
          this.listStaffProfiles();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error");
        }
      }
    );
  }

  getDataFromList(name:string, ref:number) {
    this.adminName = name;
    this.adminRef = ref;
  }

  hasStaffProfile(adminRow: AdminData): boolean {
    return this.staffAdminRefs.indexOf(Number(adminRow.ref)) !== -1;
  }
}
